export default "__VITE_ASSET__D8L2vXJB__"